import { CircularProgress, Tab, Tabs } from '@mui/material'
import { useContext, useEffect, useState } from 'react'
import ClinicBrandPayoutReports from 'src/clinic/views/clinicBrandPayoutReports/ClinicBrandPayoutReports'
import { EVENT_TYPE_CONSULTATION, EVENT_TYPE_THERAPY_SESSION } from 'src/consumer/constants'
import { MentorClinicsContext } from 'src/mentor/layout'
import { AvailabilityPageContainer } from '../MentorAvailabilityPage/MentorAvailabilityPageStyles'
import MentorHeader from '../MentorHeader'

const PreTitleMap = {
  [EVENT_TYPE_CONSULTATION]: 'Consultation',
  [EVENT_TYPE_THERAPY_SESSION]: 'Therapy',
}

export default function OwnerPayoutReport({ eventType, showSummaryReport = false }) {
  const { associatedClinicBrands, associatedClinicsData, loadingAssociationsData } =
    useContext(MentorClinicsContext)

  const [selectedClinicBrandId, setSelectedClinicBrandId] = useState()

  useEffect(() => {
    if (associatedClinicBrands && associatedClinicBrands?.length > 0) {
      setSelectedClinicBrandId(associatedClinicBrands?.[0]?.id)
    }
  }, [associatedClinicBrands])

  return (
    <AvailabilityPageContainer>
      <MentorHeader heading={`${PreTitleMap?.[eventType] || ''} Payout Reports`} />
      {!loadingAssociationsData ? (
        <>
          {associatedClinicBrands?.length > 1 && (
            <Tabs
              sx={{ px: 2 }}
              value={selectedClinicBrandId}
              onChange={(e, val) => {
                console.log({ e, val })
              }}
            >
              {associatedClinicBrands?.map((brand) => (
                <Tab
                  label={brand?.brandName || brand?.title || ''}
                  key={brand?.id}
                  value={brand?.id}
                />
              ))}
              {/* <Tab label="Item Two" {...a11yProps(1)} />
        <Tab label="Item Three" {...a11yProps(2)} /> */}
            </Tabs>
          )}
          {selectedClinicBrandId && (
            <ClinicBrandPayoutReports
              apiUrl="/api/secure/clinic-admin/reports/payout-reports-for-doctor-admin/paginated"
              isForClinicBrand={true} // Ensure this is explicitly set
              eventType={eventType}
              //   thisClinicBrandData={selectedClinicBrand}
              clinicBrandId={selectedClinicBrandId}
              showSummaryReport={showSummaryReport}
            />
          )}
        </>
      ) : (
        <CircularProgress />
      )}
    </AvailabilityPageContainer>
  )
}
